import { render } from "./S171161.vue?vue&type=template&id=aa239228"
const script = {}
script.render = render

export default script